// src/components/layout/MainFooter.tsx
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

const socialLinks = [
  { icon: Facebook, href: "https://facebook.com", label: "Facebook" },
  { icon: Twitter, href: "https://twitter.com", label: "Twitter" },
  { icon: Instagram, href: "https://instagram.com", label: "Instagram" },
  { icon: Linkedin, href: "https://linkedin.com", label: "LinkedIn" },
];

export const MainFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative border-t backdrop-blur-md bg-background/80">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <img src="/Logo.svg" alt="Guardian Logo" className="h-8 w-auto dark:hidden" />
            <img src="/Logo2.svg" alt="Guardian Logo" className="h-8 w-auto hidden dark:block" />
            <div className="h-4 w-px bg-border hidden md:block" />
            <div className="flex flex-col">
              <p className="text-sm text-muted-foreground text-center md:text-left">
                © {new Date().getFullYear()} GuardianCheckin.{" "}
                {t("footer.allRightsReserved")}
              </p>
              <p className="text-xs text-muted-foreground/70 text-center md:text-left">
                {t("footer.verifiedBy")}
              </p>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="flex items-center gap-6"
          >
            {socialLinks.map((social) => (
              <motion.a
                key={social.href}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <social.icon className="w-4 h-4" />
                <span className="sr-only">{social.label}</span>
              </motion.a>
            ))}
          </motion.div>
        </div>
      </div>
    </footer>
  );
};
